// Typography
import { ValueOf } from "@shared/types/utils";

const pxFontSizes = Object.freeze({
  XXXL: 50,
  XXL: 32,
  XL: 18,
  L: 16,
  M: 14,
  S: 12,
  XS: 10,
} as const);

export type FontSizesPixels = typeof pxFontSizes;
export type FontSizesPixelsStrings = {
  [K in keyof FontSizesPixels]: `${FontSizesPixels[K]}px`;
};
export type PxFontSize = keyof FontSizesPixels;
export type FontSizesValue = ValueOf<FontSizesPixelsStrings>;

const fontSizes = Object.entries(pxFontSizes).reduce((acc, [key, val]) => {
  //@ts-ignore
  acc[key] = val + "px";
  return acc;
}, {}) as FontSizesPixelsStrings;

const fontWeights = Object.freeze({
  NORMAL: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
} as const);

export type FontWeightValue = ValueOf<typeof fontWeights>;

export const typography = {
  fontFamily:
    "NunitoSans, Inter,-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n" +
    "    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n" +
    "    'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Noto Sans SC',\n" +
    "    sans-serif",
  fontSizes,
  pxFontSizes,
  fontWeights,
};

/**
 * The new look is lighter: nothing goes above semibold. The keys stay the same
 * so components read one scale in both looks.
 */
export const newLookTypography = {
  ...typography,
  // A touch lighter than the classic weights: Inter is variable, so the
  // in-between weights render (the new look read slightly too heavy).
  fontWeights: {
    ...fontWeights,
    SEMI_BOLD: 560,
    BOLD: 560,
    EXTRA_BOLD: 560,
  } as unknown as typeof fontWeights,
};
